// PrivateRoute.js
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

const PrivateRoute = ({ element, ...rest }) => {
  const { auth } = useAuth();

  if (!auth) {
    return <Navigate to="/login" />;
  }
  return element;
};

export default PrivateRoute;
